const canvaRegularTypes = [
  { name: 'A4Document' },
  { name: 'Announcement' },
  { name: 'BirthdayCard' },
  { name: 'BirthdayInvitation' },
  { name: 'BookCover' },
  { name: 'Bookmark' },
  { name: 'Brochure' },
  { name: 'BusinessCard' },
  { name: 'Calendar' },
  { name: 'Card' },
  { name: 'Certificate' },
  { name: 'DesktopWallpaper' },
  { name: 'EmailHeader' },
  { name: 'EtsyShopCover' },
  { name: 'EtsyShopIcon' },
  { name: 'Flyer' },
  { name: 'GiftCertificate' },
  { name: 'Infographic' },
  { name: 'Invitation' },
  { name: 'Invoice' },
  { name: 'Label' },
  { name: 'LargeRectangleAd' },
  { name: 'LeaderboardAd' },
  { name: 'LessonPlan' },
  { name: 'Letter' },
  { name: 'Logo' },
  { name: 'MagazineCover' },
  { name: 'MediumRectangleAd' },
  { name: 'Menu' },
  { name: 'MindMap' },
  { name: 'Newsletter' },
  { name: 'PhotoCollage' },
  { name: 'PodcastCover' },
  { name: 'Postcard' },
  { name: 'Poster' },
  { name: 'Presentation' },
  { name: 'Presentation43' },
  { name: 'ProductLabel' },
  { name: 'RecipeCard' },
  { name: 'Resume' },
  { name: 'Ticket' },
  { name: 'WattpadBookCover' },
  { name: 'WeddingInvitation' },
  { name: 'WideSkyscraperAd' },
  { name: 'Worksheet' },
  { name: 'Yearbook' },
]

const canvaSocialTypes = [
  { name: 'BlogBanner' },
  { name: 'FacebookAd' },
  { name: 'FacebookAppAd' },
  { name: 'FacebookCover' },
  { name: 'FacebookEventCover' },
  { name: 'FacebookPost' },
  { name: 'InstagramPost' },
  { name: 'InstagramStory' },
  { name: 'LinkedInBanner' },
  { name: 'PinterestGraphic' },
  { name: 'SnapchatGeofilter' },
  { name: 'SocialMedia' },
  { name: 'TumblrGraphic' },
  { name: 'TwitterHeader' },
  { name: 'TwitterPost' },
  { name: 'YouTubeChannelArt' },
  { name: 'YouTubeThumbnail' },
]

const canvaCustomSocialTypes = [
  {
    name: 'LinkedInPost',
    value: { width: '1200', height: '627' },
    isCustom: true,
  },
  {
    name: 'LinkedInStories',
    value: { width: '1080', height: '1920' },
    isCustom: true,
  },
]

export { canvaRegularTypes, canvaSocialTypes, canvaCustomSocialTypes }
